import { Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import "./AnalyticsCard.css"
function AnalyticsCard({ title,titleSize,height, children, removePaddingTitle }) {
  //const navigate = useNavigate();

  return (
    <Card  className="analytics-card">
      <CardActionArea onClick={() => console.log("clicked")}>
        <CardContent>
          <Typography variant={"h6"} style={{ fontWeight: 'bold', fontSize: titleSize || "", height : height }}>
            {title}
          </Typography>
          {!removePaddingTitle && <br></br>}
          {children}
        </CardContent>
      </CardActionArea>
    </Card>
  );
} export default AnalyticsCard;
